<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Whitelisting" title="New Whitelisting Request" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					
					<div class="card">
						<div class="card-body">

							<form  @submit.prevent="" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="type">
													<option value="">Select Type</option>
													<option value="1">SMS</option>
													<option value="2">Data</option>
												</select>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Profile<span class="text-danger">*</span></label>
												<select class="form-select" v-model="profile">
													<option value="">Select Profile</option>
													<option value="1">AIRTEL+BSNL</option>
													<option value="2">Vodafone+BSNL</option>
													<option value="3">AIRTEL+Vodafone</option>
												</select>
											</div>
										</div>
									
										<div class="col-md-2" style="margin-top: 33px;">
											<div class="mb-3">
												<!-- <button class="btn btn-warning me-2" @click.prevent="downloadFile">Download</button> -->
												<button class="btn btn-warning me-2" v-if="!download.loading" @click.prevent="downloadFile">Download</button>
												<img class="page-loader" v-else src="@/assets/images/ajax-loader.gif"/>
											</div>
										</div>
									</div>

									<!-- Upload Section -->
									<div v-if="showUploadSection" class="text-center mt-4">
										<p class="text-warning">
											*Please change the cell format to text before uploading xls/xlsx file.
										</p>

										<i class="fa fa-5x fa-file-excel-o" alt="XLSX Icon"></i>

										<div class="form-check mt-3 text-start mx-auto" style="max-width: 700px;">
											<input class="form-check-input" type="checkbox" id="agree" v-model="agreed" />
											<label class="form-check-label" for="agree">
											<ol class="text-muted small">
												<li>As per the DoT mandate, SMS (outgoing/incoming) from M2M SIMs are allowed to a maximum of 4 numbers only.</li>
												<li>Please do not attach any prefix (0, +91, 91) before the number to be whitelisted.</li>
												<li>SMS Whitelisting is applicable as per MNOs setup.</li>
											</ol>
											</label>
										</div>

										<input type="file" accept=".xls,.xlsx" class="form-control mt-3" @change="e => file = e.target.files[0]" style="max-width: 400px; margin: 0 auto;"/>

										<button class="btn btn-warning mt-3" :disabled="!agreed || !file" @click="uploadFile">Upload</button>

										<p v-if="!agreed" class="text-danger mt-2">Please check the checkbox before proceed</p>
									</div>

	
								</div>
							</form>
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<!-- <label class="control-label">Logo </label> -->
							<input class="form-control" type="file" accept=".xls, .xlsx" />
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	  
   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "",
		
		data() {
	      
			return {
				type: '',
				profile: '',

				showUploadSection: false,
				agreed: false,
				file: null,

				download: {
					loading: false,
				}

			};
		},
		mounted() {},

		created() {

		},

		methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			}, 

			downloadFile() {
				this.getToken();
				this.download.loading = true;

				const formData = new FormData();
				formData.append("type", this.type);
				formData.append("profile", this.profile);

				const config = {
					headers: {
						"Content-Type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token
					},
					responseType: 'blob' // <-- must be outside headers
				};

				const url = "trazio/downloadWhitelistRequest";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						const blob = new Blob([response.data], { type: response.headers['content-type'] });
						const link = document.createElement('a');
						link.href = URL.createObjectURL(blob);

						let fileName = 'whitelist_request.csv';
						const contentDisposition = response.headers['content-disposition'];
						if (contentDisposition) {
							const match = contentDisposition.match(/filename="?(.+)"?/);
							if (match && match.length > 1) {
								fileName = match[1];
							}
						}

						link.setAttribute('download', fileName);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.download.loading = false;

						this.clearForm();
						setTimeout(() => {
							this.$router.push({ name: 'view_whitelist_request' });
						}, 300);
					})
					.catch(async (error) => {
						this.download.loading = false;
						if (error.response) {
							let responseData = error.response.data;

							// If responseType is 'blob', convert to JSON
							if (responseData instanceof Blob) {
								const text = await responseData.text();
								try {
									responseData = JSON.parse(text);
								} catch (e) {
									this.$swal("Error", "Failed to parse error response", "error");
									return;
								}
							}

							// 422 with object message
							if (error.response.status === 422 && typeof responseData.message === 'object') 
							{
								this.errors = responseData.message;
								const firstError = Object.values(responseData.message)[0][0] || "Validation error";
								this.$swal("Validation Error", firstError, "error");

							} // 422 with string message
							else if (error.response.status === 422 && typeof responseData.message === 'string') 
							{
								this.$swal("Error", responseData.message, "error");
							} // Other common errors
							else if (error.response.status === 401) 
							{
								this.$swal("Unauthorized", "Please login again", "error");
							} else if (error.response.status === 500) {
								this.$swal("Server Error", "Something went wrong on server", "error");
							} else {
								this.$swal("Error", "Unexpected error occurred", "error");
							}
						} else {
							this.$swal("Network Error", error.message, "error");
						}
					});
			},

			

			uploadFile() {
				if (!this.file) return;

				const formData = new FormData();
				formData.append('file', this.file);

				try {
					alert('Upload successful');
				} catch (err) {
					console.error('Upload failed', err);
				}
			},

			clearForm() {
				this.edit = false;
				this.type = "";
				this.profile = "";
				this.errors = {};
			},

		},
	};
</script>
